<template>
    <div v-if="isAvailable">
        <b-btn class="btn-card-action btn-card-action-light my-1" @click="preDelete">Удалить</b-btn>
        <b-modal ref="delete-modal" v-model="isModalVisible" centered hide-header-close no-close-on-backdrop no-close-on-esc title="Удалить закупку">
            <div class="d-block text-left">Вы действительно хотите удалить закупку {{ purchase.purchase_info.reg_number }}?</div>
            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="cancelModal">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase" variant="custom-danger" @click="deletePurchase">Удалить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import debounceMixin from '@/mixins/debounce';

export default {
    name: 'cabinet-fl44-notice-card-delete-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    mixins: [debounceMixin],
    data() {
        return {
            isModalVisible: false,
            isDataSending: false,
            isLoading: false
        };
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        cancelModal() {
            this.isModalVisible = false;
        },
        preDelete() {
            this.isModalVisible = true;
        },
        async deletePurchase() {
            this.isDataSending = true;
            if (await this.$api.personal[this.purchase.type === 'fl44' ? 'fl44' : 'fl44UnknownVolume'].deletePurchase(this.purchase.id)) {
                this.cancelModal();
                this.$emit('action');
            }
            this.isDataSending = false;
        }
    },
    computed: {
        title() {
            return `Удалить закупку № ${this.purchase.purchase_info.reg_number}?`;
        },
        isAvailable() {
            return this.purchase.actions.delete;
        }
    }
};
</script>
